import React from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, reset } from 'redux-form'
import { required, email } from "../validations";
import { renderFieldWithShake } from "../../utils/renderFields";
import normalizeAmount from "../../utils/inputNormalizer";
import { createCashDiscountCode } from "../../actions/adminActions";

var panelStyle = { padding: '20px' } 

class CashDiscount extends React.Component {

    handleFormSubmit(values) {
        if (this.props.valid) {

            var amount = values.amount.replace("$", "");

            this.props.createCashDiscountCode(
                amount,values.description
            );
            this.props.clear();
        }
    }

    render() {
        const { handleSubmit, pristine, reset, submitting, valid, working } = this.props;

        return (

            <div>
                <br />
                <div className="container">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="panel settings-form deposit" style={panelStyle}>
                                <form id="withdraw-form" method="post" onSubmit={handleSubmit(this.handleFormSubmit.bind(this))}>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <Field
                                                name="amount"
                                                type="text"
                                                component={renderFieldWithShake}
                                                label="Amount"
                                                placeholder=" e.g. $10"
                                                validate={[required]}
                                                normalize={normalizeAmount}
                                            />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <Field
                                                name="description"
                                                type="text"
                                                component={renderFieldWithShake}
                                                label="Description"
                                                placeholder=""
                                            />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-12 text-center">
                                            <button type="submit" className={'button warning' + (!valid || pristine || submitting ? ' disabledBtn' : '')} name="button" disabled={!valid || pristine || submitting}>
                                                {working ? 'Working...' : 'CREATE DISCOUNT CODE'}
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    const { working, type, message } = state.userReducer;
    return {
        working, type, message
    };
}

function mapDispatchToProps(dispatch) {
    return {
        //functions
        createCashDiscountCode: (amount, description) => dispatch(createCashDiscountCode(amount,description)),
        clear: () => dispatch(reset('cashDiscount'))
    };

}


CashDiscount = reduxForm({
    form: 'cashDiscount'
})(CashDiscount);

CashDiscount = connect(mapStateToProps, mapDispatchToProps)(CashDiscount);

export default CashDiscount;